import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { GridComponent } from '@progress/kendo-angular-grid';
import { Subscription } from 'rxjs';

@Directive({
   selector: 'kendo-grid:[samwebKendoInfinityScrolling]',
})
export class KendoInfinityScrollingDirective implements OnInit, OnDestroy {
   constructor(private grid: GridComponent) {}

   @Input()
   public infinityScrollRequestMoreData: () => void;

   private scrollBottomSubscription: Subscription;

   ngOnInit() {
      this.scrollBottomSubscription = this.grid.scrollBottom.subscribe(() => {
         this.infinityScrollRequestMoreData();
      });
   }

   ngOnDestroy(): void {
      this.scrollBottomSubscription?.unsubscribe();
   }
}
